import { useQuery } from "@tanstack/vue-query";
import ICPService, { type ICP } from "@/services/icp/icp";

export function useICPs() {
  return useQuery({
    queryKey: ["icps"],
    queryFn: async (): Promise<ICP[]> => {
      const result = await ICPService.getICPs();
      if (result.data.status && result.data.data) {
        return result.data.data;
      }
      const payload = result.data as { errorMessage?: string };
      throw new Error(payload?.errorMessage ?? "Failed to load ICPs");
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
